import React, { useContext } from "react";
import { DataContext } from "../../contextData/contextData";
import { Icono } from "./Iconos";
import "../../css/navBar.css";
import { modalEjecutar } from "./sweetAlerts";
import { cerrarSession, returnMayus } from "../../utils/funciones";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { PUESTOS, EXISTE_MENU } from "../../utils/Constants";

const Navbar = ({ ejecutar }) => {
  const { notificaciones } = useContext(DataContext);
  const { nombreMenu } = useContext(DataContext);

  return (
    <nav className="navbar d-flex justify-content-between align-items-center navbar-expand-sm navbar-light bg-light p-1 mb-4" style={{ borderBottom: "5px solid #1D70B6" }}>
      <div>
        <div className="d-flex justify-content-start">
          <button className="btn btn-primary btnSidebar" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" style={{ paddingRight: "10px" }}>
            <Icono iconName="arrowRight" />
          </button>
          <span className="h3 mb-0 ms-3 d-flex align-items-center">{nombreMenu}</span>
        </div>
      </div>

      <ul id="itemBar" className="navbar-nav mb-lg-0 d-flex justify-content-end flex-row bgArcopime">
        <li className="d-flex flex-column justify-content-center px-2" style={{ whiteSpace: "nowrap", fontSize: "14px" }}>
          <label className="text-white text-end"> {returnMayus(localStorage.getItem("usuarioNombre"))} </label>
          <hr className="lineaPerfil" />
          <label className="text-white fw-bold text-end">
            {" "}
            {/* {localStorage.getItem("perfil").toUpperCase()} */}
            {PUESTOS[localStorage.getItem("id_perfil") || "SIN DEFINIR"].toUpperCase()}{" "}
          </label>
        </li>

        <li className="nav-item">
          <div className="dropdown text-end">
            <div className="p-2 d-block link-dark text-decoration-none dropdown-toggle btnCerrarSesion rounded-3" id="dropdownUser1" data-bs-toggle="dropdown">
              {/* <img
                src={require("../../assets/untitled.png")}
                alt="mdo"
                width="40"
                height="40"
                className="rounded-circle"
              /> */}
              <img src={`https://${localStorage.getItem("foto_perfil")}`} alt="mdo" width="40" height="40" className="rounded-circle" />

              {notificaciones.length > 0 && (
                <span
                  className="badge bg-warning text-dark p-1 rounded-circle d-flex justify-content-center"
                  style={{
                    position: "absolute",
                    fontSize: "11px",
                    top: "30px",
                    right: "62px",
                    height: "20px",
                    width: "20px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  <Icono iconName="notif" />
                </span>
              )}
            </div>
            <ul className="dropdown-menu dropdown-menu-end text-small" aria-labelledby="dropdownUser1">
              {notificaciones.length > 0 && (
                <li key={0} className="dropdown-item fw-bold d-flex justify-content-between align-items-center px-2" style={{ cursor: "pointer", padding: "6px 2px 6px 1px" }}>
                  Notificaciones
                  <span
                    className="badge rounded-pill bg-warning text-dark d-flex justify-content-center align-items-center"
                    style={{
                      height: "20px",
                      width: "20px",
                      paddingBottom: "6px",
                    }}
                  >
                    {notificaciones.length}
                  </span>
                </li>
              )}
              {EXISTE_MENU === "1" && (
                <li className="dropdown-item-li" key={1}>
                  <a className="dropdown-item px-2 d-flex justify-content-between align-items-center" onClick={ejecutar}>
                    Volver al menú
                    {/* "lg" | "xs" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x" */}
                    <FontAwesomeIcon icon={faArrowsRotate} size="lg" />
                  </a>
                </li>
              )}
              <li className="dropdown-item-li" key={2}>
                <a
                  className="dropdown-item px-2 d-flex justify-content-between align-items-center"
                  onClick={() => {
                    modalEjecutar(cerrarSession, "Se cerrará la sesión, ¿Desea continuar?", null);
                  }}
                >
                  Cerrar sesión
                  <FontAwesomeIcon size="lg" icon={faArrowRightFromBracket} />
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
